module.exports = __webpack_public_path__ + "static/img/inmeeting-phone.f092f8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/home/meeting-room/inmeeting-phone.png
// module id = t4hZ
// module chunks = 1